import {
  USER_SET_IS_RBICONNECT,
  USER_SET_USER_ACCESS,
  USER_SET_USER_BRANDS,
  USER_SET_USER_INFO,
  USER_SET_USER_PERMISSIONS,
  USER_SET_USER_ROLES,
} from '../action-types/user-types';
import axios from 'axios';

const frumEndpoint = window['runConfig'].frumBaseUrl;
const USERSENDPOINT = process.env.REACT_APP_ENDPOINT_FRUM_USERINFO;
const PERMISSIONSENDPOINT = process.env.REACT_APP_ENDPOINT_FRUM_PERMISSIONS;
const ROLESENDPOINT = process.env.REACT_APP_ENDPOINT_FRUM_ROLES;
export const setUserInfo = payload => ({
  type: USER_SET_USER_INFO,
  payload,
});
export const setUserPermissions = payload => ({
  type: USER_SET_USER_PERMISSIONS,
  payload,
});
export const setUserRoles = payload => ({
  type: USER_SET_USER_ROLES,
  payload,
});
export const setIsRBIConnect = () => ({
  type: USER_SET_IS_RBICONNECT,
});
export const setUserBrands = payload => ({
  type: USER_SET_USER_BRANDS,
  payload,
});
export const setUserAccess = payload => ({
  type: USER_SET_USER_ACCESS,
  payload,
});
export const setRBIConnectUser = (profile, permissions) => dispatch => {
  dispatch(setIsRBIConnect());
  dispatch(setUserInfo(profile));
  dispatch(setUserPermissions(permissions));
  localStorage.setItem('permissions', btoa(permissions));
  const profileHeader = JSON.stringify({
    userId: profile.name,
    loginName: profile.preferred_username,
    userType: 'corporate_admin',
  });
  localStorage.setItem('profile', profileHeader);
};

export const setFrumUser =
  (username, selectedBrand, userInfo = {}) =>
    async dispatch => {
      try {
        const result = !Object.keys(userInfo).length
          ? await axios.get(
            `${frumEndpoint}${USERSENDPOINT}?oktaUsername=${username}`,
          )
          : { data: userInfo };
        const role = await axios(`${frumEndpoint}${ROLESENDPOINT}`);
        if (Array.isArray(result.data.result.payload)) {
          result.data.result.payload = result.data.result.payload[0];
          result.data.payload = result.data.payload[0];
        }
        const defRole = role?.data.result.payload.filter(
          e => e.id === result.data.result.payload.config.roleId,
        );
        dispatch(setUserInfo({ ...result, role: defRole[0] }));
        dispatch(setUserBrands(result.data.result.payload.userBrands));
        const userBrandId = !selectedBrand
          ? result.data.payload.userBrands[0]
          : result.data.payload.userBrands.find(b => b.brandId === selectedBrand);
        const permissions = await axios.get(
          `${frumEndpoint}${PERMISSIONSENDPOINT}/${userBrandId.brandId}/users/${userBrandId.id ? userBrandId.id : userBrandId.userId
          }/permissions`,
        );
        localStorage.setItem(
          'permissions',
          btoa(permissions.data.result.payload),
        );
        const profile = JSON.stringify({
          userId: result.data.payload.userId,
          loginName: result.data.payload.loginName,
          userType: result.data.payload.userType,
        });
        localStorage.setItem('profile', profile);
        dispatch(setUserPermissions(permissions.data.result.payload));
        return result;
      } catch (error) {
        return error.response;
      }
    };
